import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface NotificationPanelState {
  show: boolean
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
}

const initialState: NotificationPanelState = {
  show: false,
  message: '',
  type: 'info'
}

const notificationPanelSlice = createSlice({
  name: 'notificationPanel',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<{ message: string; type: NotificationPanelState['type'] }>) => {
      state.show = true
      state.message = action.payload.message
      state.type = action.payload.type
    },
    hideNotification: (state) => {
      state.show = false
      state.message = ''
    }
  }
})

export const { showNotification, hideNotification } = notificationPanelSlice.actions
export default notificationPanelSlice.reducer
